__turbopack_context__.v({
  "conter": "ProductToPresent-module-scss-module__tziosq__conter",
  "disable": "ProductToPresent-module-scss-module__tziosq__disable",
});
